(() => {
  const triggerSel = "[data-km-cart-trigger]";
  const drawerSel =
    "cart-drawer-component#km-cart-drawer, cart-drawer-component[data-km-cart-drawer]";

  function safeCloseDialog(drawer) {
    try {
      const dlg = drawer?.querySelector?.("dialog");
      if (!dlg) return;
      dlg.removeAttribute("open");
      if (typeof dlg.close === "function") dlg.close();
    } catch {}
  }

  function getBestDrawer() {
    const all = Array.from(document.querySelectorAll(drawerSel));
    if (!all.length) return null;

    // ✅ Preferir o que foi movido pro body (storefront)
    const moved =
      all.find((d) => d.dataset.kmMoved === "1") ||
      all.find((d) => d.parentElement === document.body);

    // fallback: último encontrado
    return moved || all[all.length - 1];
  }

  function pruneDuplicates(keep) {
    const all = Array.from(document.querySelectorAll(drawerSel));
    all.forEach((d) => {
      if (d !== keep) {
        safeCloseDialog(d);
        d.remove();
      }
    });
  }

  function openDrawer() {
    const drawer = getBestDrawer();
    if (!drawer) return;

    // mata duplicados antes de abrir (garante abrir sempre o “bom”)
    pruneDuplicates(drawer);

    if (typeof drawer.open === "function") drawer.open();
    else if (typeof drawer.showDialog === "function") drawer.showDialog();
    else drawer.setAttribute("open", "");
  }

  function onClick(e) {
    const btn = e.target.closest(triggerSel);
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    openDrawer();
  }

  // Captura alto pra não “perder” clique no overlay/header
  document.addEventListener("click", onClick, true);

  // Se qualquer update injetar outro drawer, limpamos depois
  document.addEventListener("cart:updated", () => {
    const drawer = getBestDrawer();
    if (drawer) pruneDuplicates(drawer);
  });
})();